/* CreateAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateQuestionComponent = require("./CreateQuestionComponent");

class CreateAction {
    constructor(logger, gameEditor, modalUserFeedback, DeviceEntity, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._deviceEntity = new DeviceEntity(userSession.activeOrganization.id);
        this._activeOrgId = userSession.activeOrganization.id;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._userDataStorage = this._gameEditor._storageFactory.getRemoteStorageInstance(
            "view",
            "device_details"
        );
        this.run = this.run.bind(this);
    }

    run() {
        const selectedSite =
            this._userDataStorage.getData("site_tree_selected") || this._activeOrgId;
        return this._modalUserFeedback
            .displayCustom(
                new CreateQuestionComponent(
                    this._logger,
                    this._gameEditor._sitePaths,
                    selectedSite
                ),
                {dontHide: true}
            )
            .then((result) => {
                this._modalUserFeedback.displayLoading();
                return this._createDevice(result.name.trim(), result.site).catch((err) => {
                    this._logger.warn({error: err}, "CreateAction._createDevice() error.");
                    return this._modalUserFeedback.displayError(err);
                });
            })
            .then((result) => {
                let editorState = {
                    fqn: Registrations.DIE_VIEW_DETAILS,
                    viewState: {createMode: true},
                };
                let launchOpts = {
                    id: result.id,
                    title: result.properties.name,
                };
                this._modalUserFeedback.hideDisplayed();
                this._gameEditor.launchDeviceEditor(editorState, launchOpts);
                if (
                    typeof this._activeView.resetSelection === "function" &&
                    typeof this._activeView.loadAndScrollTo === "function"
                ) {
                    this._activeView.resetSelection([result.id]);
                    this._activeView.loadAndScrollTo(result.id);
                }
            })
            .catch((err) => {
                if (err && !err.userRejected) {
                    this._logger.warn({error: err}, "CreateAction._createDevice() - Error");
                    return this._modalUserFeedback.displayError(err);
                } else {
                    this._modalUserFeedback.hideDisplayed();
                }
            });
    }

    _createDevice(name, siteId) {
        this._deviceEntity.name = name;
        if (siteId) {
            this._deviceEntity.setSiteRelationship(siteId);
        }

        return this._deviceEntity.create();
    }
}
module.exports = CreateAction;

CreateAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
    "$teve.userSession",
    "gameEditor.activeView",
];

CreateAction.$displayDetails = {
    type: "Action",
    name: "CreateAction",
    icon: "configdrift.add_device",
    shown: true,
    title: "Add device",
    order: 3,
};
